/* eslint-disable */
import React, { Suspense } from "react";
import ReactDOM from "react-dom/client";
import ReactGA from "react-ga4";
import { BrowserRouter as Router } from "react-router-dom";
import "./index.css";
import reportWebVitals from "./reportWebVitals";
import { Routes } from "./router/routes";
import { Provider } from "react-redux";
import store from "./store";
import { ErrorBoundary } from "react-error-boundary";
import Layout from "./components/Layout";
import { CircularProgress, ThemeProvider } from "@mui/material";
import { QueryClient, QueryClientProvider } from "react-query";
import { PersistGate } from "redux-persist/integration/react";
import { persistStore } from "redux-persist";
import Theme from "styles/MuiTheme";

import { LicenseInfo } from "@mui/x-data-grid-premium";
import { MUI_KEY } from "constants/constants";
import { fallbackRender } from "components/FallbackRender";
import { TourContextProvider } from "contexts/TourContext";
import { LanguageContextProvider } from "contexts/LanguageContext";
import { Languages } from "types";

if (MUI_KEY) LicenseInfo.setLicenseKey(MUI_KEY);

const queryClient = new QueryClient();
export const persistor = persistStore(store);

window.React = React;

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

ReactGA.initialize("G-017PCG9FL3");

root.render(
  <React.StrictMode>
    <Provider store={store}>
      <PersistGate persistor={persistor}>
        <LanguageContextProvider>
          <QueryClientProvider client={queryClient}>
            <ThemeProvider theme={Theme}>
              <Router>
                <TourContextProvider>
                  <Routes />
                </TourContextProvider>
              </Router>
            </ThemeProvider>
          </QueryClientProvider>
        </LanguageContextProvider>
      </PersistGate>
    </Provider>
  </React.StrictMode>
);
if (navigator.language.includes(Languages.CHINESE)) {
  var scriptElement = document.createElement("script");
  scriptElement.src =
    "https://hm.baidu.com/hm.js?a63ddfde456e8ad01b9bdc09b203dd46";
  var firstHeadChild = document.head.firstChild;
  document.head.insertBefore(scriptElement, firstHeadChild);
  scriptElement.async = true;
}

reportWebVitals();
